import { render, staticRenderFns } from "./ClientCatalogManager.vue?vue&type=template&id=9f138d0a"
import script from "./ClientCatalogManager.vue?vue&type=script&lang=js"
export * from "./ClientCatalogManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports